/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Form } from '@unform/web';
import { FiUser } from 'react-icons/fi';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import TableLoader from '../../../../components/TableLoader';
import Modal from '../../../../components/Modal';
import { Container, Content } from './styles';
import Input from '../../../../components/Input';
import AuthService from '../../../../services/auth';
import Button from '../../../../components/Button';
import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';

interface ConfirmationModalProps {
  show: boolean;
  title: string;
  text: string;
  handleClose(): void;
}

const ModalResetPassword: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  title,
  text,
}) => {
  const formRef = useRef<FormHandles>(null);
  const formSenha = useRef<FormHandles>(null);
  const service = { AuthService: new AuthService() };
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  const { push } = useHistory();

  const schemaReset = Yup.object().shape({
    username: Yup.string().required('Login é obrigatório'),
  });

  const handleSubmitSenha = useCallback(
    async (data: any) => {
      try {
        formSenha.current?.setErrors({});

        await schemaReset.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        await service.AuthService.resetPassword(data.username);

        setLoading(false);

        addToast({
          type: 'success',
          title: 'Solicitação recebida com sucesso',
          description: 'Em breve você receberá um link para alteração de senha',
        });

        push('/');
      } catch (err: any) {
        const { ...error } = err;

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: `${
            error.response.data.message
              ? error.response.data.message
              : error.response.data.detail
          }`,
          description: `${
            error.response.data.message
              ? error.response.data.message
              : error.response.data.detail
          }`,
        });
      }
      setLoading(false);
    },
    [schemaReset, addToast],
  );

  return (
    <Container>
      <Modal title={title} handleClose={handleClose} show={show}>
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <Content>
              <p className="bodyText">{text}</p>

              <Form
                ref={formSenha}
                onSubmit={handleSubmitSenha}
                placeholder="E-mail"
                method="post"
                className="login"
              >
                <Input
                  id="username"
                  name="username"
                  icon={FiUser}
                  className="login"
                  placeholder="Login"
                  schema={schemaReset}
                />
                <div>
                  <Button
                    color="orange"
                    padding="0"
                    type="submit"
                    className="resetPassword"
                  >
                    Redefinir senha
                  </Button>
                </div>
              </Form>
            </Content>
          </>
        )}
      </Modal>
    </Container>
  );
};

export default ModalResetPassword;
